import { lazy } from 'react';
import './App.css';
import Discover from './Discover/Discover';
import SiteLayout from './components/SiteLayout';
import ErrorBoundary from './ErrorBoundary';
import { withAPI } from './API';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import { useScope } from './lib/useScope';
import { BreadcrumbProvider } from './lib/BreadcrumbContext';

// Route-level code splitting: everything except Discover (the `/` route,
// which must paint first) loads on demand. SiteLayout renders the single
// <Suspense> boundary that covers all of these.
const Event = lazy(() => import('./Event/Event'));
const RapSheet = lazy(() => import('./RapSheet/RapSheet'));
const AircraftPage = lazy(() => import('./Aircraft/Aircraft'));
const Region = lazy(() => import('./Region/Region'));
const About = lazy(() => import('./About'));
const Styleguide = lazy(() => import('./Styleguide'));

const ICAO24_PATTERN = /^[0-9a-f]{6}$/i;

// Legacy deep link `/:icao24/:zoom` (e.g. from old bookmarks/QR codes).
// Redirect to the current aircraft page when the first segment looks like a
// real icao24; otherwise an arbitrary two-segment path shouldn't produce a
// broken aircraft page, so send it home instead.
function LegacyAircraftRedirect() {
  const { icao24 } = useParams();
  if (!ICAO24_PATTERN.test(icao24 ?? '')) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/a/${icao24.toLowerCase()}`} replace />;
}

function App({ api }) {

  const scope = useScope();

  return (
    <ErrorBoundary>
    <Router>
      <BreadcrumbProvider>
      <div className="app">
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/e/:id" element={<Event api={api} />} />
            <Route path="/a/:icao24/near/:geohash5" element={<RapSheet api={api} />} />
            <Route path="/a/:icao24" element={<AircraftPage api={api} />} />
            <Route path="/r/:geohash5" element={<Region api={api} mode="geohash5" />} />
            <Route path="/n/:slug" element={<Region api={api} mode="slug" />} />
            <Route path="/about" element={<About />} />
            <Route path="/__styleguide" element={<Styleguide />} />
            <Route path="/" element={<Discover api={api} scope={scope} />} />
          </Route>
          <Route path="/:lat/:lon/:zoom" element={<Navigate to="/" replace />} />
          <Route path="/:icao24/:zoom" element={<LegacyAircraftRedirect />} />
        </Routes>
      </div>
      </BreadcrumbProvider>
    </Router>
    </ErrorBoundary>
  );
}

export default withAPI(App);
